import Api from "../../app/api";
import { useState } from "react";

export default function Password({ email, token, navigate, setStep }) {
    const [loading, setLoading] = useState(false);
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const handleForgotResetPassword = (e) => {
        e.preventDefault();
        setLoading(true);

        if (password.toString().length < 8) {
            alert("รหัสผ่านต้องมีตัวอักษรอย่างน้อย 8 ตัว");
            return;
        }

        if (password !== confirmPassword) {
            alert("รหัสผ่านและยืนยันรหัสผ่านไม่ตรงกัน");
            return;
        }

        // Send
        const formData = new FormData();
        formData.append("token", token);
        formData.append("email", email);
        formData.append("password", password);
        formData.append("password_confirmation", confirmPassword);

        Api.post("/auth/forgot/password", formData)
            .then((response) => {
                const data = response.data;

                if (data.message === "OK") {
                    const waitAlert = alert("เปลี่ยนรหัสผ่านเสร็จสิ้นกรุณาเข้าสู่ระบบด้วยรหัสผ่านใหม่");
                    if (waitAlert === undefined) {
                        navigate("/login");
                    }
                }

                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                console.error(error);
                alert("เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง");
            });
    };

    return (
        <>
            <div className="h3">ลืมรหัสผ่าน</div>
            <div>R-DNAM ฐานข้อมูลเครื่องหมายดีเอ็นเอข้าว</div>

            <form onSubmit={handleForgotResetPassword} className="mt-5">
                <div className="mb-3">
                    <label htmlFor="exampleInputPassword1" className="form-label" style={{ fontSize: 12 }}>
                        New Password
                    </label>
                    <input
                        type="password"
                        className="form-control"
                        id="exampleInputPassword1"
                        value={password}
                        required
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>
                <div className="mb-3">
                    <label htmlFor="exampleInputPassword2" className="form-label" style={{ fontSize: 12 }}>
                        Confirm Password
                    </label>
                    <input
                        type="password"
                        className="form-control"
                        id="exampleInputPassword2"
                        value={confirmPassword}
                        required
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                </div>

                <div className="d-flex justify-content-between flex-wrap align-items-center">
                    <div className="mt-4">
                        <span className="a-style" onClick={() => navigate("/login")}>
                            เข้าสู่ระบบ
                        </span>
                        <span className="a-style mx-4" onClick={() => navigate("/register")}>
                            สมัครสมาชิก
                        </span>
                    </div>
                    <div className="mt-4">
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            ส่งรหัสยืนยัน
                        </button>
                    </div>
                </div>
            </form>
        </>
    );
}
